import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const UserAddNews = () => {
    // ✅ BULLETPROOF URL LOGIC
    // .env માં ગમે તે હોય, આપણે પ્રોપર બેઝ URL બનાવીશું
    const getBaseUrl = () => {
        let url = process.env.REACT_APP_API_URL || "http://localhost:8000";
        url = url.replace(/\/$/, ""); // છેલ્લો સ્લેશ કાઢો
        if (url.endsWith('/api')) url = url.slice(0, -4); // જો /api હોય તો કાઢો
        return url;
    };

    const API_BASE = getBaseUrl();

    // Endpoints for News & Categories
    const NEWS_API = `${API_BASE}/api/news`;
    const CATEGORY_API = `${API_BASE}/api/news/categories`;

    const navigate = useNavigate();
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const fullName = localStorage.getItem("fullName") || "";

    const handleAuthFailure = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("role");
        localStorage.removeItem("userId");
        localStorage.removeItem("fullName");
        localStorage.removeItem("email");
        navigate("/login");
    };

    useEffect(() => {
        if (!token) {
            handleAuthFailure();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const categoryGroups = [
        "Proudtapi",
        "Maru Gujarat",
        "India",
        "World",
        "General"
    ];

    const [formData, setFormData] = useState({
        writer: fullName, // ✅ Auto-fill with user's name
        title: "",
        categoryGroup: "",
        category: "",
        shortDesc: "",
        content: "",
        status: "Published", // ✅ Default to Published for users
        image: null,
        videoUrl: "",
        adTitle: "",
        adImage: null,
        adLink: ""
    });

    const [preview, setPreview] = useState(null);
    const [adPreview, setAdPreview] = useState(null);
    const [validated, setValidated] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const [categories, setCategories] = useState([]);
    const [apiCategories, setApiCategories] = useState([]);

    // ✅ FETCH CATEGORIES FROM API
    useEffect(() => {
        fetchCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const normalizeCategories = (cats) => {
        return cats.map((cat) => {
            if (typeof cat === "string") {
                return { name: cat, group: "General" };
            }
            return {
                _id: cat._id,
                name: cat.name || "",
                group: cat.group || "General"
            };
        });
    };

    const fetchCategories = async () => {
        setError('');
        try {
            console.log("DEBUG: GET Categories from:", CATEGORY_API);
            const res = await axios.get(CATEGORY_API);

            if (res.data.success) {
                const cats = res.data.categories || res.data.data || [];
                const normalized = normalizeCategories(cats);
                setApiCategories(normalized);
                setCategories(
                    normalized.reduce((unique, cat) => {
                        if (!unique.some((existing) => existing.name === cat.name && existing.group === cat.group)) {
                            unique.push(cat);
                        }
                        return unique;
                    }, [])
                );
                console.log("Categories loaded:", cats);
            } else {
                setError('Failed to load categories');
            }

        } catch (error) {
            console.error("Category Fetch Error:", error.response?.status, error.message);
            setError(`Cannot reach server at ${CATEGORY_API}`);
        }
    };

    const [showCategoryForm, setShowCategoryForm] = useState(false);
    const [newCategory, setNewCategory] = useState("");

    // ✅ ADD: format youtube URL
    const formatVideoUrl = (url) => {
        if (!url) return "";
        return url.replace("watch?v=", "embed/");
    };

    // ================= HANDLE CHANGE =================
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            const file = files && files[0];
            setFormData({ ...formData, image: file });

            if (file) {
                setPreview(URL.createObjectURL(file));
            }
        }

        else if (name === "adImage") {
            const file = files && files[0];
            setFormData({ ...formData, adImage: file });

            if (file) {
                setAdPreview(URL.createObjectURL(file));
            }
        }

        else if (name === "categoryGroup") {
            setFormData({ ...formData, categoryGroup: value, category: "" });
        }

        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const categoryExistsOnServer = (name) => {
        return apiCategories.some(
            (cat) => cat.name.toLowerCase() === name?.trim()?.toLowerCase()
        );
    };

    const ensureCategoryExists = async (categoryName, group) => {
        if (!categoryName?.trim()) return;
        if (categoryExistsOnServer(categoryName)) return;

        try {
            const token = localStorage.getItem("token");
            await axios.post(
                CATEGORY_API,
                { name: categoryName.trim(), group: group || "General" },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            await fetchCategories();
        } catch (error) {
            // Ignore duplicate creation errors, but log unexpected issues.
            if (error.response?.status !== 400) {
                console.error("Category ensure error:", error.response?.data || error.message);
            }
        }
    };

    // ✅ ADD NEW CATEGORY (with loading/error)
    const handleAddCategory = async () => {
        if (!newCategory.trim()) {
            setError('Category name required');
            return;
        }

        if (!formData.categoryGroup.trim()) {
            setError('Please select a category group first');
            return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
            setError('Session expired. Please login again.');
            handleAuthFailure();
            return;
        }

        setError('');

        try {
            console.log("Posting to:", CATEGORY_API);
            const res = await axios.post(
                CATEGORY_API,
                { name: newCategory.trim(), group: formData.categoryGroup },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.success) {
                const categoryName = res.data.category?.name || newCategory.trim();

                // ✅ FIXED: Refresh categories and properly select the new one
                await fetchCategories();

                // Set the category to the newly created one
                setFormData(prev => ({ ...prev, category: categoryName }));
                setNewCategory("");
                setShowCategoryForm(false);
                setSuccess(true);

                // Clear success message after 2 seconds
                setTimeout(() => setSuccess(false), 2000);
            } else {
                setError(res.data.message || 'Failed to create category');
            }

        } catch (error) {
            console.error("Post Category Error:", error.response?.data || error.message);
            const status = error.response?.status;
            const errorMsg = error.response?.data?.message ||
                error.response?.statusText ||
                "Failed to add category. Check server connection.";
            if (status === 401) {
                setError("Session expired. Please login again.");
                handleAuthFailure();
            } else {
                setError(errorMsg);
            }
        }
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            setError('Please fill all required fields');
            return;
        }

        // ✅ Additional client-side validation
        if (!formData.title?.trim()) {
            setError('Title is required');
            return;
        }

        if (!formData.category?.trim()) {
            setError('Category is required');
            return;
        }

        if (!formData.content?.trim()) {
            setError('Content is required');
            return;
        }

        setError('');

        await ensureCategoryExists(formData.category, formData.categoryGroup);

        const token = localStorage.getItem("token");
        if (!token) {
            setError("Session expired. Please login again.");
            handleAuthFailure();
            return;
        }

        try {
            const data = new FormData();
            data.append("writer", formData.writer?.trim() || "Anonymous");
            data.append("title", formData.title?.trim());
            data.append("category", formData.category?.trim());
            data.append("shortDesc", formData.shortDesc?.trim() || "");
            data.append("content", formData.content?.trim());
            data.append("status", formData.status || "Published");
            data.append("videoUrl", formData.videoUrl?.trim() || "");
            data.append("adTitle", formData.adTitle?.trim() || "");
            data.append("adLink", formData.adLink?.trim() || "");

            if (formData.image) data.append("image", formData.image);
            if (formData.adImage) data.append("adImage", formData.adImage);

            console.log("Publishing news to:", NEWS_API);
            const response = await axios.post(NEWS_API, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`
                }
            });

            console.log("API RESPONSE:", response.data);

            if (response.data.success) {
                setSuccess(true);
                setError('');

                // Reset form
                setFormData({
                    writer: fullName, // ✅ Keep user's name
                    title: "",
                    category: "",
                    categoryGroup: "",
                    shortDesc: "",
                    content: "",
                    status: "Published", // ✅ Default to Published
                    image: null,
                    videoUrl: "",
                    adTitle: "",
                    adImage: null,
                    adLink: ""
                });
                setPreview(null);
                setAdPreview(null);
                setValidated(false);

                // Redirect to manage news after successful post
                navigate("/user-panel/manage-news");

                // Clear success message after 3 seconds
                setTimeout(() => setSuccess(false), 3000);
            } else {
                setError(response.data.message || 'Failed to publish news');
            }

        } catch (error) {
            console.error("Publish Error:", error.response?.data || error.message);

            let errorMsg = 'Error publishing article. Please try again.';
            const status = error.response?.status;

            if (status === 400) {
                errorMsg = error.response?.data?.message || 'Invalid input - check all fields';
            } else if (status === 401) {
                errorMsg = 'Session expired. Please login again.';
                handleAuthFailure();
            } else if (status === 403) {
                errorMsg = 'Unauthorized - only admin can publish';
            } else if (status === 413) {
                errorMsg = 'File size too large';
            } else if (error.message === 'Network Error' || !error.response) {
                errorMsg = `Cannot reach server at ${NEWS_API}. Check if backend is running.`;
            }

            setError(errorMsg);
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <Card className="shadow-sm">
                <Card.Header className="bg-primary text-white">
                    <h3>📰 Add News Article</h3>
                </Card.Header>
                <Card.Body>
                    {error && (
                        <Alert variant="danger" onClose={() => setError('')} dismissible className="mb-3">
                            {error}
                        </Alert>
                    )}
                    {success && (
                        <Alert variant="success" onClose={() => setSuccess(false)} dismissible className="mb-3">
                            News article published successfully!
                        </Alert>
                    )}


                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Row className="g-3">

                            {/* TITLE */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>News Title</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        placeholder="Enter news title"
                                    />
                                </Form.Group>
                            </Col>

                            {/* CATEGORY GROUP */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Category Group</Form.Label>
                                    <Form.Select
                                        required
                                        name="categoryGroup"
                                        value={formData.categoryGroup}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Group</option>
                                        {categoryGroups.map((group, index) => (
                                            <option key={index} value={group}>
                                                {group}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="d-flex justify-content-between">
                                        <span>Category</span>
                                        <Button
                                            variant="link"
                                            size="sm"
                                            onClick={() => setShowCategoryForm(!showCategoryForm)}
                                        >
                                            + Add New
                                        </Button>
                                    </Form.Label>

                                    <Form.Select
                                        required
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                        disabled={!formData.categoryGroup}
                                    >
                                        <option value="">Select Category</option>
                                        {categories
                                            .filter((cat) => cat.group === formData.categoryGroup)
                                            .map((cat, index) => (
                                                <option key={index} value={cat.name}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>

                                {showCategoryForm && (
                                    <div className="mt-2 d-flex gap-2 flex-wrap">
                                        <Form.Control
                                            type="text"
                                            placeholder={`Enter new ${formData.categoryGroup || 'category'}`}
                                            value={newCategory}
                                            onChange={(e) => setNewCategory(e.target.value)}
                                        />
                                        <Button
                                            variant="success"
                                            size="sm"
                                            onClick={handleAddCategory}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                )}
                            </Col>

                            {/* SHORT DESC */}
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Short Description</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        name="shortDesc"
                                        value={formData.shortDesc}
                                        onChange={handleChange}
                                        placeholder="Enter short description"
                                    />
                                </Form.Group>
                            </Col>

                            {/* CONTENT */}
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Full Content</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        required
                                        name="content"
                                        value={formData.content}
                                        onChange={handleChange}
                                        placeholder="Write full article content..."
                                    />
                                </Form.Group>
                            </Col>

                            {/* WRITER */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Writer Name</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        name="writer"
                                        value={formData.writer}
                                        onChange={handleChange}
                                        placeholder="Enter writer name"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>

                            {/* IMAGE */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Upload Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="image"
                                        accept="image/*"
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                {preview && (
                                    <div className="mt-2">
                                        <img
                                            src={preview}
                                            alt="preview"
                                            style={{ width: "120px", height: "80px", objectFit: "cover" }}
                                        />
                                    </div>
                                )}
                            </Col>

                            {/* VIDEO */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Video URL</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="videoUrl"
                                        value={formData.videoUrl}
                                        onChange={handleChange}
                                        placeholder="https://www.youtube.com/watch?v=xyz"
                                    />
                                </Form.Group>
                            </Col>

                            {/* VIDEO PREVIEW */}
                            {formData.videoUrl && (
                                <Col md={6}>
                                    <iframe
                                        width="100%"
                                        height="200"
                                        src={formatVideoUrl(formData.videoUrl)}
                                        title="Video Preview"
                                        allowFullScreen
                                    />
                                </Col>
                            )}

                            {/* ADS SECTION */}
                            <Col md={12}>
                                <hr />
                                <h5 className="fw-bold">Advertisement (Optional)</h5>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ad Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="adTitle"
                                        value={formData.adTitle}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            {/* AD IMAGE */}
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ad Image Upload</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="adImage"
                                        accept="image/*"
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                {adPreview && (
                                    <div className="mt-2">
                                        <img
                                            src={adPreview}
                                            alt="ad preview"
                                            style={{ width: "120px", height: "80px", objectFit: "cover" }}
                                        />
                                    </div>
                                )}
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ad Link</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="adLink"
                                        value={formData.adLink}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            {/* STATUS */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="Published">Published</option>
                                        <option value="Draft">Draft</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {/* BUTTONS */}
                            <Col md={12} className="text-end">
                                <Button
                                    type="submit"
                                    variant="primary"
                                    className="px-4 me-2"
                                >
                                    Publish Article
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={() => navigate("/user-panel/manage-news")}
                                >
                                    Back
                                </Button>
                            </Col>

                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default UserAddNews;
